
import { DistanceData, SwingTendency } from './types';
import { PuttingResult } from "@/types/puttingResults";

// Process driver results data using tendencies from the database
// We're not concerned with specific distances here
export const processDriverDistanceData = async (
  tendencies: SwingTendency[],
  distanceKey: string, 
  pointKey: string,
  selectedLevel: string | null
): Promise<DistanceData> => {
  let left = 0;
  let center = 0;
  let right = 0;
  let total = 0;
  let points = 0;
  
  // Get all driver tendencies and filter by level if needed
  const filteredTendencies = tendencies.filter(t => 
    t.club_type === 'driver' && 
    (selectedLevel === null || t.test_level === selectedLevel)
  );
  
  console.log(`Processing driver tendencies, found:`, filteredTendencies.length);
  
  // Count each tendency type
  filteredTendencies.forEach(t => {
    if (t.tendency === 'left') {
      left += 1;
    } else if (t.tendency === 'center') {
      center += 1;
    } else if (t.tendency === 'right') {
      right += 1;
    }
    // Add points if they exist
    if (t.points) {
      points += t.points;
    }
    total += 1;
  });
  
  return { left, center, right, total, points };
};

export const processLegacyDriverData = (
  driverFilteredResults: PuttingResult[], 
  distanceKey: string, 
  pointKey: string
): DistanceData => {
  let left = 0;
  let center = 0;
  let right = 0;
  let total = 0;
  let points = 0;
  
  driverFilteredResults.forEach(result => {
    // Get metadata from the result
    const metadata = result.metadata || {};
    const tendencyKey = `${pointKey}_tendency`;
    const pointsKey = `${pointKey}_points`;
    
    if (metadata[tendencyKey]) {
      const tendency = String(metadata[tendencyKey]).toLowerCase();
      
      // Increment the appropriate counter
      if (tendency.includes('left')) {
        left += 1;
        total += 1;
      } else if (tendency.includes('right')) {
        right += 1;
        total += 1;
      } else if (tendency.includes('center')) {
        center += 1;
        total += 1;
      }
      
      // Get points if they exist
      if (metadata[pointsKey]) {
        const pointValue = Number(metadata[pointsKey]);
        if (!isNaN(pointValue)) {
          points += pointValue;
        }
      }
    }
  });
  
  return { left, center, right, total, points };
};
